<template>
  <div class="extraInfo">
    <p>
      <div class="included m-t-2" v-if="activity.translations[language].included">
        <h4>{{t('What\'s included')}}</h4>
        <div v-for="line in activity.translations[language].included.split('\n')">
          <p>{{line}}</p>
        </div>
      </div>
      <div class="aditionalServices m-t-2 p-b-1" v-if="activity.translations[language].aditional_services">
        <h4>{{t('Aditional services')}}</h4>
        <div v-for="line in activity.translations[language].aditional_services.split('\n')">
          <p>{{line}}</p>
        </div>
      </div>
      <hr/>
      <div class="m-t-2 cancelationDays m-b-1">
        <i class="fa fa-ban"></i>
        {{t('Free cancellation')}} <b>{{activity.cancelation_days}}</b> <span v-if="activity.cancelation_days != 1">{{t('days')}}</span> <span v-else>{{t('day')}}</span> {{t('in advance.')}}</span>
      </div>
      <div class="bookingInfo">
        <i class="fa fa-info-circle" aria-hidden="true"></i>
        {{t('All booking information including promoter data and meeting point are included in your booking confirmation voucher.')}}
      </div>
    </div>
  </div>
</template>


<script>
  import { mapState } from 'vuex';

  export default {
    name: 'ActivityExtraInfo',
    components: {
    },
    data() {
      return {
      };
    },
    computed: {
      ...mapState({
        language: state => state.language,
        activity: state => state.activityPublic.activity,
      }),
    },
    watch: {

    },
  };
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables-b4"; /* for $brand-primary */
@import "../../../static/MDB-PRO/sass/mdb/free/data/colors";
@import "../../assets/scss/variables";
.extraInfo {
  p {
    margin-bottom: 0;
    min-height: 24px;
  }
}
.bookingInfo, .cancelationDays {
  font-size: 0.9rem;
  text-indent: -9px;
  padding-left: 16px;
}

.fa {
  display: inline-block;
  padding-right: 0.2em;
}

.fa-info-circle {
  color: $brand-primary;
}

.fa-ban {
  font-size: 16px;
  color: #E64A19;
}
</style>



// WEBPACK FOOTER //
// ActivityExtraInfo.vue?08eb09e2